module.exports = __webpack_public_path__ + "img/10019.40a37e20.jpg";